import type { ContactTemplateType } from '../../types/contact';
import type { CompanyData } from '../../types/company';
import { companyPlan } from '../../constants/enum';

/**
 * プラン番号からプラン名を取得する
 */
const getPlanName = (plan: number): string => {
  switch (plan) {
    case companyPlan.free:
      return 'フリー';
    case companyPlan.standard:
      return 'スタンダード';
    case companyPlan.pro:
      return 'プロ';
    case companyPlan.custom:
      return 'オーダーメード';
    default:
      return '';
  }
};

/**
 * お問い合わせテンプレートを生成する
 */
export const generateContactTemplate = (
  templateType: ContactTemplateType,
  companyData?: CompanyData,
): string => {
  switch (templateType) {
    case 'withdrawal':
      return `退会を希望しております。
退会理由:
（こちらに退会理由をご記入ください）`;

    case 'plan_change':
      return `プラン変更を希望しております。
現在のプラン: ${companyData ? getPlanName(companyData.plan) : ''}
希望プラン: （フリー / スタンダード / プロ / オーダーメード）
希望開始時期:
（例: 2025年1月1日から）`;

    case 'additional_user':
      return `追加ユーザーの申込を希望しております。
現在のプラン: ${companyData ? getPlanName(companyData.plan) : ''}
現在のユーザー数: ${companyData ? companyData.current_user_count : ''}名 / ${companyData ? companyData.user_limit : ''}名
追加希望人数: （   ）名
希望開始時期:
（例: 2025年1月1日から）`;

    case 'ocr_credit':
      return `OCRクレジットの購入を希望しております。
現在のプラン: ${companyData ? getPlanName(companyData.plan) : ''}
現在のOCRクレジット残高: ${companyData ? companyData.ocr_credit_balance : 0}円
希望購入金額: （50,000円～）`;

    case 'other':
    default:
      return '';
  }
};

/**
 * URLパラメータからテンプレート種別を取得する
 */
export const getTemplateTypeFromParams = (
  category?: string,
  type?: string,
): ContactTemplateType => {
  // typeパラメータが指定されている場合は優先
  if (type === 'withdrawal') return 'withdrawal';
  if (type === 'plan_change') return 'plan_change';
  if (type === 'additional_user') return 'additional_user';
  if (type === 'ocr_credit') return 'ocr_credit';

  // categoryのみの場合はその他
  return 'other';
};
